import { Controller } from "@hotwired/stimulus"

export default class DropdownController extends Controller {

  connect() {
    const dropdownMenu = this.element.querySelector(".dropdown-menu")
    const displaySpan = this.element.querySelector(".selected-value-display")
    const checked = dropdownMenu.querySelector(".form-check-input:checked")

    if (checked) {
      const label = checked.nextElementSibling.textContent.trim()
      displaySpan.textContent = label
    }

    this.boundHandleShow = this.handleShow.bind(this)
    document.addEventListener("show.bs.dropdown", this.boundHandleShow)
  }

  disconnect() {
    document.removeEventListener("show.bs.dropdown", this.boundHandleShow)
  }

  handleShow(event) {
    const targetDropdown = event.target.closest(".dropdown")
    const targetDropdownMenu = targetDropdown.querySelector(".dropdown-menu");
    const targetToggle = event.target.querySelector('[data-bs-toggle="dropdown"]');

    // Manage single-open dropdown state across comments and posts sections
    document.querySelectorAll("#updated_comment_list .dropdown, .group-posts .dropdown").forEach((dropdown) => {
      const dropdownToggle = dropdown.querySelector(':scope > [data-bs-toggle="dropdown"]');
      const dropdownMenu = dropdown.querySelector(".dropdown-menu");
      const isTarget = dropdownMenu === targetDropdownMenu;
      if (!isTarget && dropdownToggle && dropdownMenu.classList.contains("show")) {
          bootstrap.Dropdown.getOrCreateInstance(dropdownToggle).toggle();
      }

      if (isTarget && targetToggle && !dropdownMenu.classList.contains("show")) {
          bootstrap.Dropdown.getOrCreateInstance(targetToggle).toggle();
      }
    })
  }

  replay_option(event){
    const target = event.currentTarget
    const dropdownMenu = target.closest(".dropdown-menu")
    const dropdown = dropdownMenu.closest(".dropdown")
    const displaySpan = dropdown.querySelector(".selected-value-display")
    const checkboxes = dropdownMenu.querySelectorAll(".form-check-input")
    for (const cb of checkboxes){
      if (cb !== target) cb.checked = false
    }

    if (target.checked) {
      const label = target.nextElementSibling.textContent.trim()
      displaySpan.textContent = label
    } else {
      displaySpan.textContent = "Select"
    }
  }
}
